import * as React from "react"

type ProductPrice = {
  price: number
  salePrice?: number
}

export const ProductPrice: React.FC<ProductPrice> = ({ price, salePrice}) => {
  return (
    <div className="h-16 flex items-end">
      {salePrice ? <ProductPriceWithSale price={price} salePrice={salePrice} /> : <ProductPriceRegular price={price} />}
    </div>
  )
}

export const ProductPriceRegular: React.FC<{ price: number }> = ({price}) => {
  const priceString = price.toLocaleString() + '円'

  return <div className="ml-8 lg:ml-4 text-4xl text-red-600 lg:text-3xl">
    {priceString}
    <span className="text-xs align-text-bottom" style={{writingMode: 'vertical-rl'}}>(税込)</span>
  </div>
}

export const ProductPriceWithSale: React.FC<{ price: number, salePrice: number }> = ({price, salePrice}) => {
  const priceString = price.toLocaleString() + '円'
  const salePriceString = salePrice.toLocaleString() + '円'

  return (
    <div className="ml-8 lg:ml-4">
      <div className="text-lg py-1 line-through" style={{ color: '#0c4a6e' }}>
        {priceString}
      </div>
      <div className="text-4xl text-red-600 lg:text-3xl">
        {salePriceString}
        <span className="text-xs align-text-bottom" style={{writingMode: 'vertical-rl'}}>(税込)</span>
      </div>
    </div>
  )
}
